import React from 'react'
import Invoices from './Common/Invoices'

const History = () => <Invoices apiEndpoint='/api/invoices/history' />

export default History
